import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { MdChat } from "react-icons/md";
import { Button, InputGroup, FormControl, Container, Row, Col, Card } from "react-bootstrap";

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      user: "bot",
      text: "Hi there! I'm your CV assistant. How can I help you with your CV today?",
    },
  ]);

  const toggleChatbox = () => {
    setIsOpen(!isOpen);
  };

  const handleUserMessage = (userMessage) => {
    setMessages([...messages, { user: "user", text: userMessage }]);
    setTimeout(() => {
      const botResponse = getBotResponse(userMessage);
      setMessages((prevMessages) => [...prevMessages, { user: "bot", text: botResponse }]);
    }, 1000);
  };

  const getBotResponse = (message) => {
    const lowerMessage = message.toLowerCase();
    if (lowerMessage.includes("cv")) {
      return "I can help you with creating or improving your CV. What section would you like to work on?";
    } else if (lowerMessage.includes("experience")) {
      return "Great! Adding relevant work experience can really boost your CV. Can you tell me more about your past job roles?";
    } else if (lowerMessage.includes("education")) {
      return "Your education is a key part of your CV. What qualifications would you like to include?";
    } else if (lowerMessage.includes("skills")) {
      return "Great! What skills do you have that you'd like to showcase on your CV?";
    } else {
      return "I didn't quite catch that. Could you please clarify what you'd like help with?";
    }
  };

  return (
    <Container>
      <Button variant="primary" className="position-fixed bottom-0 end-0 m-3 rounded-circle" onClick={toggleChatbox}>
        <MdChat size={30} color="#fff" />
      </Button>

      <Card className={`position-fixed bottom-0 end-0 m-3 p-2 ${isOpen ? "d-block" : "d-none"}`} style={{ width: "300px", height: "400px" }}>
        <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
          <span>Chatbot</span>
          <Button variant="link" className="text-white" onClick={toggleChatbox}>
            <FaTimes size={20} />
          </Button>
        </Card.Header>
        <Card.Body className="bg-light overflow-auto" style={{ flex: 1 }}>
          {messages.map((msg, index) => (
            <Row key={index} className="mb-2">
              <Col className={msg.user === "bot" ? "text-start" : "text-end"}>
                <div className={`p-2 rounded ${msg.user === "bot" ? "bg-secondary text-white" : "bg-primary text-white"}`}>
                  {msg.text}
                </div>
              </Col>
            </Row>
          ))}
        </Card.Body>
        <Card.Footer>
          <InputGroup>
            <FormControl
              placeholder="Ask me about CV creation..."
              onKeyDown={(e) => {
                if (e.key === "Enter" && e.target.value.trim()) {
                  handleUserMessage(e.target.value);
                  e.target.value = "";
                }
              }}
            />
          </InputGroup>
        </Card.Footer>
      </Card>
    </Container>
  );
};

export default Chatbot;
